/*
 * @Description: 投稿模块
 * @Author: jiang.weiwei
 * @LastEditors: pu.yuchun
 * @Date: 2017-12-06 19:46:00
 * @LastEditTime: 2019-10-25 16:05:19
 */
'use strict';
angular
    .module('submissionManageModule', [
        'submissionRouterModule',
        'personalLibraryModule', //个人稿库
        'pgcPersonalLibraryModule', //pgc个人稿库
        'submissionLibraryModule', //已投稿库
        'pgcSubmissionLibraryModule', //pgc已投稿库
        'explosionManageModule', //爆料管理
        'publishExplosionModule' //已发布爆料
    ])
    .controller('submissionManageCtrl', [function() {}]);
